import { useContext, useEffect } from 'react'

import { Box, Button, Input, Select, Text } from '@fairfashion/design-system'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { useTheme } from 'styled-components'

import { sdk } from '../../../../services/sdk'
import { FeedbackAlertContext } from '../../../FeedbackAlert'
import { ICompanyProductionCapacitiesForm } from '../../production-capacity.types'

import { ICompanyProductionCapacityFormModal } from './production-capacity-form-modal.types'

export const ProductionCapacityFormModal = ({
  companyId,
  categories,
  capacitiesData,
  index,
  setModalOpen,
  getCompanyProductionCapacities,
}: ICompanyProductionCapacityFormModal) => {
  const theme = useTheme()

  const { feedbackAlert } = useContext(FeedbackAlertContext)
  const { control, register, handleSubmit, reset } =
    useForm<ICompanyProductionCapacitiesForm>({
      defaultValues: {
        capacities: [],
      },
    })
  const { fields: capacities } = useFieldArray({
    control,
    name: 'capacities',
  })

  const submitCapacity = async (data: ICompanyProductionCapacitiesForm) => {
    try {
      await sdk.companyProduction.createCompanyProductionCapacities(
        companyId,
        data,
      )
      reset(data)
      feedbackAlert('Salvo com sucesso', 'success')
      getCompanyProductionCapacities()
    } catch (error) {
    } finally {
      setModalOpen(false)
    }
  }

  const getFilteredOptions = (index: number) => {
    const selectedOptions = capacities.map((c) => c.finishedItemCategoryId)
    selectedOptions.splice(index, 1)

    return categories
      .filter((c) => !selectedOptions.includes(c.id))
      .map((c) => ({
        label: c.name,
        value: c.id,
      }))
  }
  useEffect(() => {
    reset({
      capacities: capacitiesData ?? [],
    })
  }, [capacitiesData, reset])
  return (
    <form onSubmit={handleSubmit(submitCapacity)}>
      <Box width="100%" direction="column" gap={2}>
        <Text size="small" fontWeight={500}>
          Capacidade de produção
        </Text>
        <Box width="100%" flex={1}>
          <Controller
            control={control}
            name={`capacities.${index}.finishedItemCategoryId`}
            render={({ field }) => (
              <Select
                label="Categoria"
                options={getFilteredOptions(index)}
                placeholder="Escolha uma categoria"
                {...field}
              />
            )}
          />
        </Box>
        <Box width="100%" flex={1}>
          <Input
            {...register(`capacities.${index}.capacity`)}
            label="Capacidade"
          />
        </Box>
        <Box width="100%" flex={1}>
          <Input
            {...register(`capacities.${index}.taxUnit`)}
            label="Unidade de medida"
          />
        </Box>
        <Box
          width="100%"
          justifyContent="flex-end"
          marginTop={1}
          alignItems="center"
          gap={1}
        >
          <Button
            fontSize={theme.typography.body_size.small}
            variant="outlined"
            onClick={() => setModalOpen(false)}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSubmit(submitCapacity)}
            fontSize={theme.typography.body_size.small}
          >
            Salvar
          </Button>
        </Box>
      </Box>
    </form>
  )
}
